import { defineStore } from "pinia";
import { privateBoaHttp } from "@/boa-api-client";

type Claim = any;

type State = {};

export default defineStore("claims", {
  state: (): State => ({}),
  getters: {},
  actions: {
    async getClaims(): Promise<{ claims: any[] }> {
      const response: { claims: any[] } = await privateBoaHttp("claims").json();
      return response;
    },
    async updateClaim(claim: Claim) {
      const response = await privateBoaHttp
        .post(`claims/${claim.candidateId}`, { json: { claim } })
        .json();
      return response;
    },
    clear() {
      this.$reset();
    },
  },
});
